// @react/hooks/useDocument.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { documentStore } from '@core/stores';

/**
 * React hook for Document operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useDocument } from '@react/hooks';
 *
 * const DocumentList = observer(() => {
 *   const store = useDocument();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useDocument() {
  return documentStore;
}
